<mat-stepper role="presentation" linear #stepperHorLin [orientation]="(stepperOrientation | async)!" id="linearHorizontalStepper">

    <ng-template matStepperIcon="edit">
      <span aria-hidden="true">{{ stepperHorLin.selectedIndex + 1 }}</span>
    </ng-template>

    <mat-step [stepControl]="horizLinPersonalInfo">
      <form [formGroup]="horizLinPersonalInfo">
         <ng-template matStepLabel>
          <span aria-label="1 MCT Personal Info">MCT Personal Info</span>
        </ng-template>

        <div class="grid-layout">
          <div class="form-row">
            <mat-form-field class="form-field-flex">
              <input type="text" placeholder="First Name*" matInput formControlName="firstname" aria-label="First Name" />
              <mat-error
                *ngIf="!horizLinPersonalInfo.get('firstname')?.valid && horizLinPersonalInfo.get('firstname')?.touched && horizLinPersonalInfo.get('firstname')?.errors?.required">
                First name is required</mat-error>
              <mat-error
                *ngIf="horizLinPersonalInfo.get('firstname')?.touched && horizLinPersonalInfo.get('firstname')?.errors?.pattern">
                First name can contain only letters</mat-error>
            </mat-form-field>
            <mat-form-field class="form-field-flex">
              <input type="text" placeholder="Last Name*" matInput formControlName="lastname" aria-label="Last Name" />
              <mat-error
                *ngIf="!horizLinPersonalInfo.get('lastname')?.valid && horizLinPersonalInfo.get('lastname')?.touched && horizLinPersonalInfo.get('lastname')?.errors?.required">
                Last name is required</mat-error>
              <mat-error
                *ngIf="horizLinPersonalInfo.get('lastname')?.touched && horizLinPersonalInfo.get('lastname')?.errors?.pattern">
                Last name can contain only letters</mat-error>
            </mat-form-field>
          </div>

          <div class="email-note-group">
            <mat-form-field>
              <input type="text" placeholder="Email*" matInput formControlName="email" aria-label="Email" />
              <mat-error
                *ngIf="!horizLinPersonalInfo.get('email')?.valid && horizLinPersonalInfo.get('email')?.touched && horizLinPersonalInfo.get('email')?.errors?.required">
                Email is required
              </mat-error>
            </mat-form-field>
            <p class="email-note-text">
              <em>Email (Please use the email address associated with your MS Learn Profile)</em>
            </p>
          </div>

          <mat-form-field>
          <input type="text" placeholder="Contact Email" matInput formControlName="alternateEmail" aria-label="Contact Email" />
          <mat-error
            *ngIf="(horizLinPersonalInfo.get('alternateEmail')?.touched) && horizLinPersonalInfo.get('alternateEmail')?.hasError('invalidEmail')">
            Please enter a valid MCT email address
          </mat-error>
        </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Preferred Language*" formControlName="language" aria-label="Preferred Language">
              <mat-option *ngFor="let option of languageList" [value]="option.name">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="!horizLinPersonalInfo.get('language')?.valid && horizLinPersonalInfo.get('language')?.touched && horizLinPersonalInfo.get('language')?.errors?.required">
              Select the Language</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Country*" formControlName="country" (selectionChange)="onCountryChange($event)" aria-label="Country">
              <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                {{ option.countryName }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="!horizLinPersonalInfo.get('country')?.valid && horizLinPersonalInfo.get('country')?.touched && horizLinPersonalInfo.get('country')?.errors?.required">
              Select the Country</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Timezone*" formControlName="timezone" aria-label="Timezone">
              <mat-option *ngFor="let option of timezoneList" [value]="option.timeZone">
                {{ '(GMT' + option.utcOffset + ') ' + option.displayName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="!horizLinPersonalInfo.get('timezone')?.valid && horizLinPersonalInfo.get('timezone')?.touched && horizLinPersonalInfo.get('timezone')?.errors?.required">
                            Select the Timezone</mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Employment Type*" formControlName="employmentType" aria-label="Employment Type">
              <mat-option *ngFor="let option of employmentTypeList" [value]="option.value">
                {{ option.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="!horizLinPersonalInfo.get('employmentType')?.valid && horizLinPersonalInfo.get('employmentType')?.touched && horizLinPersonalInfo.get('employmentType')?.errors?.required">
              Select the Employment Type</mat-error>
          </mat-form-field>

        </div>

        <div class="step-action">
          <button *ngIf="isFromRenewal" mat-stroked-button matStepperPrevious (click)="previous()"
            id="linearStep1Previous" class="blue-border-btn" aria-label="Previous">
            Previous
          </button>

          <button mat-flat-button matStepperNext (click)="next()" id="linearStep1Next" class="btn-clr" aria-label="Next">
            Next
          </button>
        </div>
      </form>

    </mat-step>

    <mat-step [stepControl]="horizLinFavoriteThings">
      <form [formGroup]="horizLinFavoriteThings">
        <ng-template matStepLabel>
          <span aria-label="2 MCT Agreement">MCT Agreement</span>
        </ng-template>
        <div class="grid-layout" style="display: flex; flex-direction: column; gap: 8px;">

          <div class="topaz-checkbox-group-col">
            <p style="font-size: 13px; color: #595959; margin-bottom: 8px;margin-left:10px">
              <em>Note: You must review the MCT Program Agreement through the link below before you can check the box to accept it.</em>
            </p>
            <div class="basic-checkboxes">
              <mat-checkbox matInput formControlName="mctAgreement" [(ngModel)]="isCheckboxSelected" [ngClass]="{
                  'is-invalid': !isCheckboxSelected && formSubmitted
                }" class="white-check-icon" id="requiredCheckbox"
                style="--mdc-checkbox-selected-checkmark-color: white; --mat-checkbox-checkmark-color: white;">
              </mat-checkbox>
              <span class="agreement-text">By checking this box, I acknowledge that I have read and agree to the terms of the <a href="javascript:void(0)" (click)="agrementDoc()" (keydown.enter)="agrementDoc(); $event.stopPropagation()" aria-live="polite" [attr.aria-label]="'MCT Program Agreement (downloads PDF file, 150KB)'">MCT Program Agreement</a></span>
            </div>
            <mat-error class="is-invalid" *ngIf="!isCheckboxSelected && formSubmitted">
              You must accept the Agreement to continue
            </mat-error>
          </div>
        </div>
        <div class="step-action">
          <button *ngIf="!isFromRenewal" mat-button matStepperPrevious id="linearStep2Previous" aria-label="Back">
            <fa-icon style="color:#666;font-weight:400" [icon]="icons.faArrowLeft"></fa-icon>
            <span class="backbtn-txt">Back</span>
          </button>
          <button *ngIf="isFromRenewal" mat-stroked-button matStepperPrevious class="blue-border-btn" aria-label="Previous">
            Previous
          </button>
          <button [disabled]="disableSubmitButton" mat-flat-button class="btn-clr" matStepperNext id="linearStep2Next" (click)="submit()" (keydown.enter)="submit(); $event.stopPropagation()" aria-label="Submit">Submit</button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>